// extracted by mini-css-extract-plugin
module.exports = {"component":"DietFilters_component__3XZ1v","item":"DietFilters_item__32mNH","title":"DietFilters_title__3_AL2"};